import React from 'react';
import config from 'config';
import {Button, Upload, UploadProps} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useKeycloak } from '../../auth/keycloak';
import { useAppContext } from '../../context/appContext';
import { Settlement } from 'interfaces/balances';

const buildPaymentFileName = (setlementDate:string, fileName:string): string => {
	return setlementDate + "_032" + fileName.substring(fileName.indexOf("."))

}

const SettlementPaymentFileUploadButton = ({settlement, paymentType, setPayment}: {settlement: Settlement, paymentType:string, setPayment:(string)=>void}) => {
	const {settings: {issuer, routeIssuer}} = useAppContext();
	const {keycloak} = useKeycloak();

	const uploadUrl = config.api.url + "/v1/reports/payment"

	keycloak
		.updateToken(5)
		.then(() => {
			localStorage.setItem('kc_token', keycloak.token);
			localStorage.setItem('kc_refreshToken', keycloak.refreshToken);
		})
    .catch(() => keycloak.login());

	const uploadProps: UploadProps = {
		name: 'file',
		action: uploadUrl,
		data: {settlement_date: settlement.date, settlement_type: paymentType},
		headers: {
			'X-Prisma-Issuer': issuer?.name,
			Authorization: `Bearer ${keycloak.token}`,
			'backoffice-source': routeIssuer  
		},
		onChange: (change) => {
			if (change.file.status === 'done') {
				setPayment(buildPaymentFileName(settlement.date, change.file.name))
			}
		}
	};

	return(
		<Upload {...uploadProps}>
			<Button
				type="primary"
				icon={ <UploadOutlined/> }
				size={'middle'}
			/>
		</Upload>
	)
}

export default SettlementPaymentFileUploadButton ;
